module.exports = __webpack_public_path__ + "img/leeroy.7c157279.png";